import { render, staticRenderFns } from "./MyWebSocket.vue?vue&type=template&id=96348264&scoped=true"
import script from "./MyWebSocket.vue?vue&type=script&lang=js"
export * from "./MyWebSocket.vue?vue&type=script&lang=js"
import style0 from "./MyWebSocket.vue?vue&type=style&index=0&id=96348264&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96348264",
  null
  
)

export default component.exports